// extracted by mini-css-extract-plugin
module.exports = {"item":"OfferButton_item__HHRJj","bottomTitle":"OfferButton_bottomTitle__zgp9i","bottomDescription":"OfferButton_bottomDescription__tLIfl","reverse":"OfferButton_reverse__ZGGlw"};